import React, { memo, ReactNode } from "react";
import { Flex, Box, Text, SecurityV1, SecurityV2 } from "@edricphan2022/uikit";
import {OurValue , IconOurValue} from './style'
import IconOrbit from "../../components/IconOrbit";
import Icon1 from '../../assets/Home/icon1.svg';
import Icon2 from '../../assets/Home/icon2.svg';
import Icon3 from '../../assets/Home/icon3.svg';
import styled from "styled-components";

interface ContentProps {
  title: string;
  // des: string;
  // startIcon?: ReactNode;
  img:any;
}

const ContentSercurity: React.FC<ContentProps> = ({ title, img
  // des, startIcon 
}) => {
  return (
    <Box pb={["24px", "0"]}>
      <OurValue>
        <IconOurValue><img src={img} alt=''/></IconOurValue>
        <p>{title}</p>
      </OurValue>
    </Box>
  );
};

const SercurityServices = () => {
  return (
    <Box width="100%" margin={'auto'}>
      <BoxGroup className="orbit-flex-sercurity">
        <ContentSercurity
          title="TRANSPARENCY"
          img={Icon1}
        />
        <ContentSercurity
          title="customer-centric"
          img={Icon2}
        />
        <ContentSercurity
          title="cost-efective"
          img={Icon3}
        />
      </BoxGroup>
    </Box>
  );
};

const BoxGroup = styled(Flex)`
  padding-top: 3.63vw;
  padding-bottom: 3.63vw;
  @media only screen and (max-width: 743px){
    flex-direction: column;
    padding-top: 30px;
  }
`

export default memo(SercurityServices);
